/**
 * @generated SignedSource<<e9c1a2efb905b9c6aa4b52483d84639a>>
 * @relayHash 8b9c0375c291daba7cf62c9916d0c3d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2a03caa0f80b967283328c4df042f5464975807a20649ebc3a576b753b8dd480

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConversationReviewPageQuery$variables = {
  helpCenterAri: string;
};
export type ConversationReviewPageQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly id?: string;
  } | null | undefined;
};
export type ConversationReviewPageQuery = {
  response: ConversationReviewPageQuery$data;
  variables: ConversationReviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "CsmAiHub"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ConversationReviewPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConversationReviewPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "2a03caa0f80b967283328c4df042f5464975807a20649ebc3a576b753b8dd480",
    "metadata": {},
    "name": "ConversationReviewPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "73eac69f8ce47cb4805683a20dacdd34";

export default node;
